import EcoNavProduct, { EcoNavProductProps } from 'eco-design/sections/eco-nav-product';
import { useRouter } from 'next/router';
import { productPageUrl } from '../../config/pageConfig';
import styles from './index.module.scss';
import { LangText } from './LangText';
export default function ProductNav({ activeTab, tabCallback }: { activeTab: string; tabCallback?: any }) {
    const { locale = 'us', pathname, query } = useRouter();
    const TextA = LangText[locale] || LangText['us'];
    const thePageUrl = `/${locale}/${productPageUrl}`;
    const isInProductPage = pathname.endsWith(productPageUrl);

    const dataA: EcoNavProductProps = {
        theme: 'black',
        defaultProductActiveKey: 'name1',
        productItems: [
            {
                value: 'name2',
                label: TextA.product_name1,
                href: query?.debug ? `/${locale}/stream-ultra-home-solar-system?debug=${query.debug}` : `/${locale}/stream-ultra-home-solar-system`,
            },
            {
                value: 'name1',
                label: TextA.product_name,
                href: isInProductPage ? undefined : thePageUrl,
            },
        ],
        tabItems: [
            {
                value: 'Product',
                label: TextA.tab_product,
                href: isInProductPage ? undefined : thePageUrl,
            },
            {
                value: 'Specs',
                label: TextA.tab_specs,
                href: `${thePageUrl}/specs`,
            },
            {
                value: 'Support',
                label: TextA.tab_support,
                href: `${thePageUrl}/support`,
            },
        ],
        buyItems: [
            {
                value: 'Button',
                label: TextA.btn_buy,
                href: `https://${locale}.ecoflow.com/products/stream-microinverter`,
            },
        ],
    };

    const tabChange = (item: any, index: number) => {
        if (tabCallback) {
            tabCallback(item.value);
        }
    };

    return (
        <div className={styles.comp}>
            <EcoNavProduct {...dataA} defaultTabActiveKey={activeTab} onTabChange={tabChange} />
        </div>
    );
}
